import { useContext, useEffect } from 'react';
import { Row, Column, Button } from '@simplywallst/ui-core';
import { Hidden } from './styled';
import { RecentUpdatesList } from './components/RecentUpdatesList';
import { SideMenuContext } from '@/pages/CompanyReport/components/Overview/components/SideMenu/context';
import { useRecentUpdatesContext } from '../../context';
import { useTracking } from 'react-tracking';
import type { EventCategory } from '@/constants/events';

interface Props {
  lookup: string | null;
  filterByEventCategory?: EventCategory;
  menuTitle?: string;
  buttonTitle?: string;
}

export function MoreUpdates({
  lookup,
  buttonTitle = 'See more updates',
  menuTitle = 'Recent updates',
  filterByEventCategory,
}: Props) {
  const { showMenu, setShowMenu, createSideMenu } = useContext(SideMenuContext);
  const { filter, title, setTitle, setFilter } = useRecentUpdatesContext();
  const { trackEvent } = useTracking();
  useEffect(() => {
    if (typeof createSideMenu === 'function') {
      createSideMenu(
        <RecentUpdatesList
          title={title}
          filter={filter}
          lookup={lookup}
          onClose={() => {
            setShowMenu('closed');
          }}
        />,
        'more-updates'
      );
    }
  }, [lookup, title, filter]);

  const onClick = () => {
    if (menuTitle !== title) setTitle(menuTitle);
    if (filterByEventCategory !== filter) setFilter(filterByEventCategory);
    setShowMenu('more-updates');
    trackEvent({
      modifier: 'intro_show_all_update',
      action: 'click',
    });
  };

  return (
    <>
      <Row>
        <Column colMd={12}>
          <Button
            display="block"
            onClick={onClick}
            styleType="loud"
            data-cy-id="see-more-updates"
            disabled={filterByEventCategory === filter && showMenu}
          >
            {buttonTitle}
          </Button>
          {/* Show markup even if menu not shown */}
          {!showMenu && (
            <Hidden data-cy-id="hidden-menu">
              <RecentUpdatesList
                title={title}
                filter={filter}
                show={showMenu}
                lookup={lookup}
              />
            </Hidden>
          )}
        </Column>
      </Row>
    </>
  );
}
